export default __webpack_public_path__ + "static/media/file.18b65113.svg";